<app-header></app-header>
<div class="page-content"  *ngIf="!loading()">
  <div class="app-container">
    <h2>{{ subAppName }}</h2>
    <p>{{ subAppDescription }}</p>
    <div class="sub-app-content">
      <!-- SubApp specific content goes here -->
      <app-visa-helper *ngIf="active == apps[0]"></app-visa-helper>
      <app-transport-helper *ngIf="active == apps[1]"></app-transport-helper>
      <app-accommodation-helper *ngIf="active == apps[2]"></app-accommodation-helper>
      <app-migration-helper *ngIf="active == apps[3]"></app-migration-helper>
      <app-health-helper *ngIf="active == apps[4]"></app-health-helper>
      <app-budget-helper *ngIf="active == apps[5]"></app-budget-helper>
      <app-legal-helper *ngIf="active == apps[6]"></app-legal-helper>
    </div>
  </div>
</div>
<mat-spinner *ngIf="loading()"></mat-spinner>
<app-footer></app-footer>